var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Title',{attrs:{"heading":"Get Your Free Jewelry Insurance Quote"}},[_vm._v(" Already have a quote?  "),_c('b-link',{attrs:{"to":"/retrieve"}},[_vm._v("Retrieve your saved quote or application")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }